module.exports = __webpack_public_path__ + "media/images/front/bullet-8d42ea3452d2d477de1a314a1abb6bec.png";